module.exports = __webpack_public_path__ + "img/Hotmart-10-pt.ed9cc7f1.png";